/**
 * Consignes du panier de la boutique — même règle que la commande côté serveur
 * (packages/api/src/orders/consignes.ts) : autant de contenants que d'unités,
 * au prix de la fiche consigne, regroupés par fiche (« Consigne 75 cl × 4 »).
 *
 * Le serveur sert `deposit_cents` (déjà multiplié par le nombre de contenants
 * par unité) et `deposit_name` sur chaque produit consigné. Le montant est
 * affiché et additionné ici pour que le total vu par le client — et le
 * complément FOLIES qu'on lui propose — soit celui que le serveur facturera.
 */

interface ArticleConsignable {
  product: { is_weighted?: boolean; deposit_cents?: number | null; deposit_name?: string | null };
  quantity: number;
  quantity_unit?: 'grams' | 'pieces';
  piece_count?: number;
}

export interface LigneConsignePanier {
  name: string;
  /** Nombre d'unités vendues portant cette consigne. */
  quantity: number;
  total_cents: number;
}

/** Unités d'un article — jamais des grammes. */
function unites(item: ArticleConsignable): number {
  if (item.quantity_unit === 'pieces') return Math.max(0, Number(item.piece_count) || 0);
  if (item.product.is_weighted === true) return 0;
  return Math.max(0, Number(item.quantity) || 0);
}

export function consignesDuPanier(items: ArticleConsignable[]): LigneConsignePanier[] {
  const parNom = new Map<string, LigneConsignePanier>();
  for (const item of items) {
    const parUnite = Number(item.product.deposit_cents) || 0;
    const n = unites(item);
    if (parUnite <= 0 || n <= 0) continue;
    const name = item.product.deposit_name || 'Consigne';
    const ligne = parNom.get(name) || { name, quantity: 0, total_cents: 0 };
    ligne.quantity += n;
    ligne.total_cents += Math.round(parUnite * n);
    parNom.set(name, ligne);
  }
  return [...parNom.values()].sort((a, b) => a.name.localeCompare(b.name));
}
